import React from 'react';
import { Icon, Popup, Table } from 'semantic-ui-react';

import { Fecha, LinkAlumno } from 'src/componentes';
import { DetallesDelCurso } from '../tipos';

export const ListaDeAlumnos = (props: { curso: DetallesDelCurso }) => {
    const { curso } = props;

    return (
        <Table striped attached='bottom'>
            <Table.Header>
                <Table.Row textAlign='center'>
                    <Table.HeaderCell colSpan={2}>Alumnos del curso</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {curso.alumnos.map((alumno, indice) => (
                    <Fila key={alumno.id} alumno={alumno} numero={indice + 1} />
                ))}
            </Table.Body>

            {curso.recuperaciones.length > 0 && (
                <>
                    <Table.Header>
                        <Table.Row id='lista_recuperaciones' textAlign='center'>
                            <Table.HeaderCell colSpan={2} style={{ backgroundColor: '#eaedf1' }}>
                                Alumnos que recuperan (
                                <Fecha fecha={curso.fechaDeLaProximaClase} />)
                                <Popup
                                    trigger={<Icon name='question circle outline' />}
                                    content={
                                        'Estos alumnos solo aparecerán en la lista ' +
                                        'hasta esta fecha.'
                                    }
                                    inverted
                                    offset='-10px'
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {curso.recuperaciones.map((alumno, indice) => (
                            <Fila
                                key={alumno.id}
                                alumno={alumno}
                                numero={curso.alumnos.length + indice + 1}
                            />
                        ))}
                    </Table.Body>
                </>
            )}
        </Table>
    );
};

type Alumno = DetallesDelCurso['alumnos'][number] & DetallesDelCurso['recuperaciones'][number];

const Fila = (props: { alumno: Alumno; numero: number }) => {
    const { alumno, numero } = props;

    return (
        <Popup
            disabled={!alumno.restringido}
            trigger={
                <Table.Row negative={alumno.restringido}>
                    <Table.Cell collapsing>{numero}</Table.Cell>

                    <LinkAlumno
                        numeroDeContrato={alumno.numeroDeMatricula}
                        nombre={{ nombre: alumno.nombre, patron: '%P %M %N %S' }}
                        paraTabla
                    />
                </Table.Row>
            }
        >
            <b style={{ color: 'red' }}>Alumno restringido de clases</b>
        </Popup>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Informacion/ListaDeAlumnos.tsx